import { EOrderStatus } from '../../../model';

import { EPayPalOrderAction, IPayPalOrderState, TPayPalOrderReducer } from './model';

export const defaultState: IPayPalOrderState = {
  billingToken: '',
  facilitatorAccessToken: '',
  payerId: '',
  status: EOrderStatus.UNDEFINED,
  orderId: '',
  customer: null,
  deliveryAddress: null,
};

export const reducer: TPayPalOrderReducer = (prevState, action) => {
  switch (action.actionType) {
    case EPayPalOrderAction.CREATE:
      return {
        ...prevState,
        orderId: action.payload.orderId,
        status: EOrderStatus.CREATED,
      };

    case EPayPalOrderAction.APPROVE:
      return {
        ...prevState,
        status: action.payload.status,
        customer: action.payload.customer,
        deliveryAddress: action.payload.deliveryAddress,
        facilitatorAccessToken: action.payload.facilitatorAccessToken,
        billingToken: action.payload.billingToken,
        payerId: action.payload.payerId,
      };
    case EPayPalOrderAction.ERROR:
    default:
      return {
        ...prevState,
        status: EOrderStatus.VOIDED,
      };
  }
};
